// This file will have the web alerts components which will be imported from help components
import React from 'react';
import { Container } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { HcAlert } from '@paypalcorp/helpcomponents';
import { alertsFPTIs } from '../../../helpers/analytics/appLevelAnalytics';
import { pageNames } from '../../../common/constants';

const FPTIsMappings = {
  home: 'alertsHome',
  [pageNames.CONTACT_US]: 'alertsContactUs',
};

// get appropriate FPTIs info based on the pageName.
const getFTPIsForCurrentPage = (pageName) => alertsFPTIs[FPTIsMappings[pageName]];

const AlertsPanel = function (props) {
  return (
    <Container className="sh_alerts__panel" data-testid="sh-alerts-panel">
      <HcAlert appName="help_center" pageName={props.pageName} fptiOptions={getFTPIsForCurrentPage(props.pageName)} />
    </Container>
  );
};

AlertsPanel.propTypes = {
  pageName: PropTypes.string.isRequired,
};

export default AlertsPanel;
